class CountdownTimer extends HTMLElement {
  static get observedAttributes() {
    return ["target"];
  }

  constructor() {
    super();
    this._intervalId = null;
    this._widthLocked = false;
  }

  connectedCallback() {
    this.ensureStyles();
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this._widthLocked = false;
      this.start();
    }
  }

  ensureStyles() {
    if (document.getElementById("countdown-timer-styles")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "countdown-timer-styles";
    style.textContent = `
      countdown-timer {
        display: inline-block;
        box-sizing: border-box;
        min-width: var(--countdown-timer-width, 8ch);
        font-variant-numeric: tabular-nums;
        text-align: center;
        white-space: nowrap;
      }
    `;
    document.head.appendChild(style);
  }

  get targetDate() {
    const target = this.getAttribute("target");
    if (!target) {
      return null;
    }

    const date = new Date(target);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  start() {
    this.stop();
    this.tick();
    this._intervalId = window.setInterval(() => this.tick(), 1000);
  }

  stop() {
    if (this._intervalId !== null) {
      window.clearInterval(this._intervalId);
      this._intervalId = null;
    }
  }

  lockWidth(hours) {
    if (this._widthLocked) {
      return;
    }

    const hourDigits = Math.max(2, String(hours).length);
    const charCount = hourDigits + 6;
    this.style.setProperty("--countdown-timer-width", `${charCount}ch`);
    this._widthLocked = true;
  }

  formatTime(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.lockWidth(hours);

    const hourText = String(hours).padStart(2, "0");
    const minuteText = String(minutes).padStart(2, "0");
    const secondText = String(seconds).padStart(2, "0");

    return `${hourText}:${minuteText}:${secondText}`;
  }

  tick() {
    const target = this.targetDate;

    if (!target) {
      this.textContent = "--:--:--";
      return;
    }

    const diffMs = target.getTime() - Date.now();

    if (diffMs <= 0) {
      this.textContent = "00:00:00";
      this.stop();
      this.dispatchEvent(
        new CustomEvent("countdown-complete", { bubbles: true })
      );
      return;
    }

    const totalSeconds = Math.floor(diffMs / 1000);
    this.textContent = this.formatTime(totalSeconds);
  }
}

if (!customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}
